import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const audioSettingsParts = [
  'container',
  'dropdownContainer',
  'text',
  'select',
] as const

const helpers = createMultiStyleConfigHelpers(audioSettingsParts)

export const AudioSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      width: 'min(400px, fit-content)',
    },
    dropdownContainer: {
      flexDirection: 'column',
      marginBottom: '20px',
      gap: '8px',
    },
    text: {
      ...textStyles[textStyleKeys.Body2],
    },
    select: {
      borderColor: 'fg.default',
      color: 'fg.default',
      _hover: {
        borderColor: 'fg.default',
      },
    },
  },
  defaultProps: {},
})

export const useAudioSettingsStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(AudioSettingsStyle, props) as MultiStyleType<
    typeof audioSettingsParts
  >
}
